import React from 'react'
import PropTypes from 'prop-types'
import Dropdown from "Components/Global/Dropdown";
import {getScreeningWindowsForSchoolYear} from "Services/screeningWindowService";
import { getUserData } from '../../../../../services/API';

const ScreeningWindowSelect = ({ selection, onChange, disabled }) => {
  const handleChange = (selection) => {
    onChange && onChange(selection);
  };

  const windows = getScreeningWindowsForSchoolYear();
  let options = windows.map(window => {
    const { id, season, isCurrent, isPast} = window;

    let startDate = window.startDate;
    let endDate = window.endDate;

    if(getUserData().demoLockdown){
      startDate = windows.find(option=>option.id === "BOY").startDate;
      endDate = windows.find(option=>option.id === "EOY").endDate;
    }

    return {
      endDate: endDate.toString(),
      startDate: startDate.toString(),
      value: id,
      label: isCurrent ? `${season} (current)` : season,
      isDisabled: !isPast && !isCurrent, //disable options for future screening windows
      isCurrent,
      isPast,
      id,
    }
  });

  selection = selection && options.find(option => option.value === selection.id);

  return (
    <Dropdown options={options} value={selection} onChange={handleChange} isDisabled={disabled} />
  )
}

ScreeningWindowSelect.propTypes = {
  selection: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
}

export default ScreeningWindowSelect;